#icon {
  position: absolute;
  right: 15%;
  margin-top: -38px;
}
